module.exports = __webpack_public_path__ + "static/img/bg28.17804ddf.png";